export default "__VITE_ASSET__b1315cd0__"